/* eslint-disable no-use-before-define,react-hooks/exhaustive-deps */
import React from 'react'
import {ajax, Status, arrayFrom, getState} from '../../twd/twd'

export default () => {
    const state = getState('municipals.scatter-graph')

    const [status, setStatus] = React.useState(Status.LOADING)
    const benchmarks = ['Treasury', 'AAA', 'AA', 'A', 'BBB']
    const [benchmarksData, setBenchmarksData] = React.useState({})

    const [selectedBenchmarks, setSelectedBenchmarks_] = React.useState(state.value.selectedBenchmarks || benchmarks)
    const setSelectedBenchmarks = React.useCallback((a) => {
        state.set({selectedBenchmarks:a})
        setSelectedBenchmarks_(a)
    }, [])

    const lastAbort = React.useRef()
    React.useEffect(() => {(async () => {
        try {
            setStatus(Status.LOADING)
            let {data, abort} = await ajax({
                url: '/esb/retailservice/yieldCurveService/getBenchmarkDataByType',
                method: 'POST',
                params: {
                    bondType: 'MUNI',
                    muniType: 'GO',
                    marketSnapshotType: 'MUNICIPAL_GO_BENCHMARK_DATA',
                }
            })

            lastAbort.current = abort
            let a = (await data).benchmarkYieldValues || {}
            lastAbort.current = null

            let m = {
                'Treas': 'Treasury',
                'MuniGOAAA': 'AAA',
                'MuniGOAA': 'AA',
                'MuniGOA': 'A',
                'MuniGOBBB': 'BBB',
            }
            for (let [k, v] of Object.entries(a)) {

                let n = m[k]
                if (!n) continue

                a[n] = arrayFrom(v)
                    .map(i => {
                        i.benchmark = n
                        i.x = i.maturityYearValue
                        i.y = i.yieldValue
                        return i
                    })
                    .filter(a => (a.x<=30))
            }
            setBenchmarksData(a)

            setStatus(Status.LOADED)
        } catch(e) {
            if (lastAbort.current) lastAbort.current()
            setStatus(Status.FAILED_TO_LOAD)
        }
    })()

    return () => {
        if (lastAbort.current) lastAbort.current()
    }

    }, [])


    return {
        benchmarks,
        benchmarksStatus: status,
        benchmarksData,
        selectedBenchmarks,
        setSelectedBenchmarks
    }
}